import React from 'react';

import { MsalProvider } from '@azure/msal-react';
import { Links, LinksFunction, Meta, Outlet, Scripts } from 'react-router';

import { client } from '@af-fp/api/client.gen';
import { LoadingBlock } from '@af-fp/components/LoadingBlock';
import { GlobalErrorBoundary } from '@af-fp/components/error/GlobalErrorBoundary';
import { AuthenticationContextContainer } from '@af-fp/context/authentication';
import { publicClientApplication } from '@af-fp/oauth/microsoft';

import './index.css';

client.setConfig({
  baseUrl: import.meta.env.VITE_API_URL,
  credentials: 'include',
});

export const links: LinksFunction = () => [
  {
    rel: 'stylesheet',
    href: '/fontawesome/css/fontawesome.css',
  },
  {
    rel: 'stylesheet',
    href: '/fontawesome/css/solid.css',
  },
  {
    rel: 'stylesheet',
    href: '/fontawesome/css/regular.css',
  },
];

export const meta = () => [
  {
    title: 'Financial Planning',
  },
];

export function Layout({ children }: React.PropsWithChildren) {
  return (
    <html lang='en' className='text-[14px] lg:text-[16px]'>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  );
}

const Component: React.FC = () => {
  return (
    <MsalProvider instance={publicClientApplication}>
      <AuthenticationContextContainer>
        <Outlet />
      </AuthenticationContextContainer>
    </MsalProvider>
  );
};

export function HydrateFallback() {
  return (
    <div className='h-screen w-screen'>
      <LoadingBlock />
    </div>
  );
}

export { GlobalErrorBoundary as ErrorBoundary };

export default Component;
